//import { getCoreAjax } from '../../utils/moodle-amd';

export default () => {
  // Only run on your themed pages
  if (document.querySelector('body:not(.user-theme)')) return;

  const LOG = (...a) => {
    if (localStorage.getItem('treadmaster_video_tracking_debug') === 'true') {
      console.log('[Treadmaster video-tracking] ', ...a);
    }
  };
  const LOGTABLE = (...a) => {
    if (localStorage.getItem('treadmaster_video_tracking_debug') === 'true') {
      console.table(...a);
    }
  };

  const PROGRESS_THRESHOLD = 0.75;
  const MAX_ALLOWED_DELTA_SECONDS = 2;
  const STORE_KEY = '__treadmaster_xp_video_tracking';
  const VIDEO_SELECTOR = 'video[data-xp-video="true"]';

  const videoElements = document.querySelectorAll(VIDEO_SELECTOR);
  if (!videoElements.length) return;

  videoElements.forEach((video) => {
    gateMarkDoneButton(video);

    LOG('isActivityCompleted', isActivityCompleted(video));

    if (isActivityCompleted(video)) return;

    //
    video.addEventListener('play', () => {
      isActivityCompleted(video);

      if (!isTabActive()) return;
      if (getStore(video, 'completed')) return;
      setStore(video, 'started', true);
    });
    video.addEventListener('pause', () => {
      if (!isTabActive()) return;
      if (getStore(video, 'completed')) return;
      setStore(video, 'started', false);
    });
    video.addEventListener('timeupdate', () => {
      if (!isTabActive()) return;
      if (!getStore(video, 'started')) return;
      if (getStore(video, 'completed')) return;

      if (video.seeking) return;

      const lastTime = getStore(video, 'lastTime') || 0;
      const currentTime = video.currentTime;

      // Time difference since lastTime
      const delta = currentTime - lastTime;

      setStore(video, 'delta', delta);

      // Only consider forward progress
      if (delta < 0) return;

      // Allow some leeway for big jumps (e.g. from skipping ahead or resuming after a break)
      if (delta > MAX_ALLOWED_DELTA_SECONDS) return;

      // Store legit progress time for progress calculation
      const legitProgress = Math.max(
        getStore(video, 'legitProgress') || 0,
        video.currentTime
      );
      setStore(video, 'lastTime', currentTime);
      setStore(video, 'legitProgress', legitProgress);

      //
      const progressPercent = legitProgress / video.duration;
      if (progressPercent >= PROGRESS_THRESHOLD) {
        setStore(video, 'completed', true);
        setActivityCompleted(video);
      }
    });
  });

  function isTabActive() {
    return document.visibilityState === 'visible';
  }

  function getStore(videoElement, key) {
    if (!key && !videoElement[STORE_KEY]) {
      return {};
    }
    if (!videoElement[STORE_KEY] && key) {
      return null;
    }
    if (!key) return videoElement[STORE_KEY];
    return videoElement[STORE_KEY][key] ?? null;
  }

  function setStore(videoElement, key, value) {
    const store = getStore(videoElement);
    store[key] = value;
    videoElement[STORE_KEY] = store;

    LOGTABLE(store);
  }

  function gateMarkDoneButton(video) {
    const activityWrapper = video.closest('.activity');
    const completionButton = activityWrapper?.querySelector(
      '.activity-completion button[data-toggletype]'
    );
    if (!completionButton) return;

    completionButton.addEventListener('click', (e) => {
      LOG('Completion Button Clicked');
      LOG('isActivityCompleted', isActivityCompleted(video));

      if (isActivityCompleted(video)) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return;
      }

      // If the video is completed in store, allow moodle click to get through and mark activity as done
      if (getStore(video, 'completed') && !isActivityCompleted(video)) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    });
  }

  function isActivityCompleted(video) {
    const activityWrapper = video.closest('.activity');
    const completionButton = activityWrapper?.querySelector(
      '.activity-completion button[data-toggletype]'
    );
    if (!completionButton) return true;

    if (completionButton.dataset.toggletype !== 'manual:mark-done') {
      return true;
    }

    return false;
  }

  function setActivityCompleted(video) {
    const activityWrapper = video.closest('.activity');
    const completionButton = activityWrapper?.querySelector(
      '.activity-completion button[data-toggletype]'
    );
    if (!completionButton) return;

    if (completionButton.dataset.toggletype === 'manual:mark-done') {
      completionButton.click();
    }
  }

  /*
  async function isActivityComplete() {
    const Ajax = await getCoreAjax();

    const courseid = Number(M?.cfg?.courseId);
    const userid = document.querySelector('#usernavigation *').dataset.userid;

    console.log(courseid);
    console.log(userid);

    if (!courseid || !userid) {
      console.warn('[xp-video] missing courseid/userid', { courseid, userid });
      return;
    }

    const res = await new Promise((resolve, reject) => {
      const requests = Ajax.call([
        {
          methodname: 'core_completion_get_activities_completion_status',
          args: {
            courseid,
            userid
          }
        }
      ]);

      // Ajax.call returns array of deferreds
      requests[0].done(resolve).fail(reject);
    });

    console.log('[xp-video] completion response', res);
  }*/
};
